import logger from 'nandos-dev-logger'
import {CUSTOMER_CHANGED} from 'nandos-middleware-api/service/customer/customer-service'

let lastUserId = null

class ECommerceTracker {

    constructor() {
        this._trackers = []
        this._customerService = null
    }

    get customerService() {
        if (this._customerService == null) throw new Error("[Nandos tracking] Missing required dependency: Customer Service")
        return this._customerService
    }

    set customerService(cs) {
        if (this._customerService) this._customerService.removeObserver(this, CUSTOMER_CHANGED)
        this._customerService = cs
        this._customerService.addObserver(this, CUSTOMER_CHANGED, () => this._checkUser())
    }

    installTrackers(...trackers) {
        this._trackers = this._trackers.concat(trackers)
    }

    track(eventType, ...rest) {
        this._checkUser() // make sure user data has been resolved and set first, then process event
            .then(user => {
                this._trackers.forEach(tracker => {
                    try {

                        if ('disabledIf' in tracker && tracker.disabledIf(eventType, rest) === true) {
                            return
                        }
                        if (tracker[eventType]) tracker[eventType](...rest)
                    } catch (e) {
                        console.warn(`failed to track event: ${eventType}, one or more trackers failed to collect this event.`)
                        console.error(e)
                    }
                })
            })
    }

    /**
     * Whenever the user changes, set the "userID" custom dimension
     */
    _checkUser() {
        return this.customerService.getMe()
            .then(user => {
                let id = user.anonymous == true ? undefined : user.id
                if (id !== lastUserId) { // if user has changed
                    lastUserId = id
                    this._trackers.forEach(tracker => tracker.setUser(user))
                }
                return user
            })
    }
}

export default new ECommerceTracker()